import { useEffect } from 'react'
import gsap, { Power4 } from 'gsap'

import ContainerSuperLoading from './styles'
import useAppConfig from '../../hooks/useAppConfig'
import { INITIAL_STATE } from '../../store/reducers/appConfig/data'

export default function SuperLoading() {
  const { appConfig, setAppConfig } = useAppConfig()

  useEffect(() => {
    setAppConfig(INITIAL_STATE[0])

    const foundItem = INITIAL_STATE[0]

    if (foundItem != null) {
      setAppConfig(foundItem)
      setCssVariable('--primary-color', foundItem.styles.primaryColor)
      setCssVariable(
        '--primary-contrast-color',
        foundItem.styles.primaryContrastColor
      )
      setCssVariable('--secondary-color', foundItem.styles.secondaryColor)
      setCssVariable('--background-color', foundItem.styles.backgroundColor)
      changeThemeColor(
        foundItem.styles.primaryColor,
        foundItem.appFavicon,
        foundItem.appTitle,
        foundItem.appDescription
      )
    }

    removeSuperLoading()
  }, [])

  function setCssVariable(variable: string, value: string) {
    document.documentElement.style.setProperty(variable, value)
  }

  function changeThemeColor(
    color: string,
    favicon: string,
    title: string,
    description: string
  ) {
    let metaThemeColor = document.querySelector('meta[name="theme-color"]')

    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', color)
    } else {
      metaThemeColor = document.createElement('meta')
      metaThemeColor.setAttribute('name', 'theme-color')
      metaThemeColor.setAttribute('content', color)
      document.head.appendChild(metaThemeColor)
    }

    let link1: HTMLLinkElement | null =
      document.querySelector('link[rel*="icon"]')

    if (!link1) {
      link1 = document.createElement('link')
      link1.rel = 'icon'
      document.head.appendChild(link1)
    }

    link1.href = favicon

    let link2: HTMLLinkElement | null = document.querySelector(
      'link[rel*="apple-touch-icon"]'
    )

    if (!link2) {
      link2 = document.createElement('link')
      link2.rel = 'icon'
      document.head.appendChild(link2)
    }

    link2.href = favicon

    window.document.title = title

    let descriptionPage: HTMLMetaElement | null = document.querySelector(
      'meta[name="description"]'
    )

    if (!descriptionPage) {
      descriptionPage = document.createElement('meta')
      descriptionPage.name = 'description'
      document.head.appendChild(descriptionPage)
    }

    descriptionPage.content = description
  }

  function removeSuperLoading() {
    const getBarStatus = window.document.getElementsByClassName(
      'content-loading-bar'
    )

    getBarStatus[0].scrollIntoView({
      behavior: 'smooth',
    })

    gsap.to(getBarStatus, {
      width: 200,
      duration: 2,
      ease: Power4.easeInOut,
    })
  }

  return (
    <ContainerSuperLoading className="box-superLoading">
      <div className="header-logo">
        <img src={appConfig?.appConfig?.appLogo} alt="App Logo" />
      </div>
      <div className="loading-bar">
        <div className="content-loading-bar" />
      </div>
    </ContainerSuperLoading>
  )
}
